/* CUSTOM JV — starea de sectiune Femei/Barbati (pattern MDV).
   Persistenta: localStorage 'jv-gender'. Reflectata in html[data-jv-gender].
   Elementele dependente de gen se marcheaza cu [data-jv-menu="femei|barbati"]. */
(function () {
  var KEY = 'jv-gender';
  var DEFAULT_GENDER = 'barbati';
  var root = document.documentElement;

  function currentGender() {
    try {
      var v = localStorage.getItem(KEY);
      if (v === 'femei' || v === 'barbati') return v;
    } catch (e) { /* privat mode etc. */ }
    return DEFAULT_GENDER;
  }

  function apply(gender, persist) {
    root.setAttribute('data-jv-gender', gender);
    if (persist) {
      try { localStorage.setItem(KEY, gender); } catch (e) { /* noop */ }
    }
    document.querySelectorAll('[data-jv-gender-link]').forEach(function (link) {
      var active = link.getAttribute('data-jv-gender-link') === gender;
      link.classList.toggle('is-active', active);
      link.setAttribute('aria-current', active ? 'true' : 'false');
    });
    document.querySelectorAll('[data-jv-gender-switch]').forEach(function (btn) {
      var active = btn.getAttribute('data-jv-gender-switch') === gender;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    document.dispatchEvent(new CustomEvent('jv:gender', { detail: { gender: gender } }));
  }

  // aplica imediat (inainte de paint, scriptul e in <head> cu defer -> la DOMContentLoaded)
  // genul din URL are prioritate: /collections/femei, /collections/femei-compleuri etc.
  function genderFromUrl() {
    var m = window.location.pathname.match(/\/collections\/(femei|barbati)(?:-|\/|$)/);
    return m ? m[1] : null;
  }

  function init() {
    var fromUrl = genderFromUrl();
    if (fromUrl) apply(fromUrl, true); else apply(currentGender(), false);
    // butoanele din meniul mobil: doar comuta categoriile, fara navigare (Robert, 16 sept)
    document.addEventListener('click', function (event) {
      var sw = event.target.closest('[data-jv-gender-switch]');
      if (sw) apply(sw.getAttribute('data-jv-gender-switch'), true);
    });
    document.addEventListener('click', function (event) {
      var link = event.target.closest('[data-jv-gender-link]');
      if (!link) return;
      var gender = link.getAttribute('data-jv-gender-link');
      apply(gender, true);
      // Prototip: cat timp linkul duce la homepage, doar comutam starea.
      // Dupa populare, href-urile devin colectiile de gen si navigarea e naturala.
      var href = link.getAttribute('href');
      if (href === '/' || href === '' || href === window.location.pathname) {
        event.preventDefault();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
